import { useEffect, useState } from "react";
import { PanelListTable } from "./panelListTable";
import { PanelListElement } from "../../../eventBus/panelListEventPayloads";
import eventBus, { IApplicationEvent } from "../../../eventBus/eventDispatcher";
import "./panelListContent.css";

export const PanelListContent = () => {
    const [panelListEntities, setPanelListEntities] = useState<PanelListElement[]>();

    useEffect(() => {
        eventBus.addEventListener("Dextall.PanelList.PanelListCreated", onPanelListCreatedUpdated);
        eventBus.addEventListener("Dextall.PanelList.EntitiesUpdated", onPanelListCreatedUpdated);

        return () => {
            eventBus.removeEventListener("Dextall.PanelList.PanelListCreated", onPanelListCreatedUpdated);
            eventBus.removeEventListener("Dextall.PanelList.EntitiesUpdated", onPanelListCreatedUpdated);
        };
    }, []);

    const onPanelListCreatedUpdated = (eventData: IApplicationEvent<PanelListElement[]>) => {
        setPanelListEntities(eventData.payload);
    };

    return panelListEntities && <PanelListTable panelListEntities={panelListEntities} />;
};
